import { render, staticRenderFns } from "./CampaignsSummary.vue?vue&type=template&id=01efcae2&scoped=true&"
import script from "./CampaignsSummary.vue?vue&type=script&lang=js&"
export * from "./CampaignsSummary.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsSummary.vue?vue&type=style&index=0&id=01efcae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01efcae2",
  null
  
)

export default component.exports